import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "field-group finance-section__body" }
const _hoisted_2 = { class: "q-ma-none q-pa-none" }
const _hoisted_3 = { class: "row no-wrap justify-end q-mt-sm q-mr-md" }
const _hoisted_4 = {
  key: 0,
  class: "field-group"
}
const _hoisted_5 = { class: "field-group__row" }
const _hoisted_6 = { class: "text-bold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "q-mb-xs",
  style: {"font-weight":"500"}
}
const _hoisted_9 = {
  key: 0,
  class: "q-ma-none q-pa-none"
}
const _hoisted_10 = { class: "row no-wrap justify-end q-my-sm q-mr-md" }
const _hoisted_11 = {
  key: 1,
  class: "field-group"
}
const _hoisted_12 = { class: "field-group__row" }
const _hoisted_13 = { class: "bold-name" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 2,
  class: "row no-wrap justify-end q-my-xs q-mr-md q-mb-md"
}
const _hoisted_16 = {
  key: 3,
  class: "row no-wrap justify-end q-my-sm q-mr-md q-mb-md"
}
const _hoisted_17 = { class: "file-list" }
const _hoisted_18 = {
  key: 0,
  class: "dialog-table"
}
const _hoisted_19 = { class: "row no-wrap justify-between" }
const _hoisted_20 = { class: "row no-wrap" }
const _hoisted_21 = { style: {"font-weight":"400","color":"#4D4D4D"} }
const _hoisted_22 = { class: "finance-section__section-title" }
const _hoisted_23 = { class: "row no-wrap" }
const _hoisted_24 = {
  key: 0,
  style: {"font-size":"12px","color":"#499259","margin-right":"5px"}
}
const _hoisted_25 = {
  key: 1,
  style: {"font-size":"14px","color":"#499259","margin-right":"5px"}
}
const _hoisted_26 = {
  key: 2,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_27 = { style: {"font-size":"12px","font-weight":"500"} }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "q-ml-sm" }
const _hoisted_30 = {
  key: 0,
  style: {"display":"contents"}
}
const _hoisted_31 = {
  key: 0,
  class: "pos_cell"
}
const _hoisted_32 = { class: "row no-wrap items-baseline q-ml-md" }
const _hoisted_33 = {
  key: 1,
  class: "shrink-col pos_cell"
}
const _hoisted_34 = {
  key: 2,
  class: "shrink-col pos_cell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_bill_create_form = _resolveComponent("bill-create-form")!
  const _component_payment_create_component = _resolveComponent("payment-create-component")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_simple_selector = _resolveComponent("simple-selector")!
  const _component_counterparty_create_form = _resolveComponent("counterparty-create-form")!
  const _component_mosta_context_menu = _resolveComponent("mosta-context-menu")!
  const _component_app_tooltip = _resolveComponent("app-tooltip")!
  const _component_bill_row = _resolveComponent("bill-row")!
  const _component_movement_row = _resolveComponent("movement-row")!
  const _component_payment_progress = _resolveComponent("payment-progress")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_position_row = _resolveComponent("position-row")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inner_container finance-section", _ctx.expanded ? 'finance-section--expanded' : '']),
    style: {"overflow":"auto","padding":"0","margin":"0"},
    onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.$emit('update:addMenuOpen', false); _ctx.accounts_tab = 'account_selector';})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_mosta_context_menu, {
        visible: _ctx.addMenuOpen,
        position: _ctx.menuPos,
        "min-width": 320,
        "z-index": 6000,
        resizable: "",
        "max-width": 560,
        "min-height": 240,
        "menu-class": "finance-add-menu-ctx",
        onClose: _ctx.onAddMenuHide,
        onContentResize: _ctx.refitAddMenu
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "finance-add-menu",
            onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_component_q_tabs, {
              modelValue: _ctx.accounts_tab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accounts_tab) = $event)),
              dense: "",
              class: "text-grey bg-white",
              "active-color": "dark",
              "indicator-color": "accent",
              align: "justify"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab, {
                  name: "account_selector",
                  "no-caps": ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('invoices_payments_unattached')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab, {
                  name: "new_bill",
                  "no-caps": "",
                  label: _ctx.$t('invoice_creation')
                }, null, 8, ["label"]),
                _createVNode(_component_q_tab, {
                  name: "new_payment",
                  "no-caps": "",
                  label: _ctx.$t('add_payment')
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_tab_panels, {
              modelValue: _ctx.accounts_tab,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.accounts_tab) = $event)),
              animated: "",
              class: "full-height bg-white",
              style: {"overflow":"hidden"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab_panel, {
                  name: "account_selector",
                  class: "bg-white full-height q-pa-xs",
                  style: {"overflow":"hidden"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_q_input, {
                        outlined: "",
                        dense: "",
                        ref: "from_search_input",
                        color: "white",
                        class: "thin-input q-my-auto",
                        modelValue: _ctx.acc_search_text,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.acc_search_text) = $event)),
                        "hide-bottom-space": "",
                        clearable: "",
                        autofocus: "",
                        "clear-icon": _ctx.clearIconName,
                        placeholder: _ctx.$t('search_label'),
                        debounce: "300",
                        onClear: _cache[2] || (_cache[2] = ($event: any) => (_ctx.acc_search_text = ''))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "search",
                            color: "accent"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "clear-icon", "placeholder"])
                    ]),
                    _withDirectives(_createVNode(_component_aux_selector, {
                      "model-type": 29,
                      "set-id": _ctx.projectId,
                      "filter-model-value": _ctx.acc_search_text,
                      "show-search-header": false,
                      "input-index": 0,
                      modelValue: _ctx.tmp_accounts,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tmp_accounts) = $event)),
                      "allow-multiple": false
                    }, null, 8, ["set-id", "filter-model-value", "modelValue"]), [
                      [_vShow, _ctx.showSelector]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab_panel, {
                  name: "new_bill",
                  class: "bg-white full-height q-pa-none q-pb-sm",
                  style: {"overflow":"hidden"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bill_create_form, {
                      modelValue: _ctx.newBill,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newBill) = $event)),
                      "incoming-only": false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab_panel, {
                  name: "new_payment",
                  class: "bg-white full-height q-pa-none q-pb-sm",
                  style: {"overflow":"hidden"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_payment_create_component, {
                      modelValue: _ctx.newPayment,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPayment) = $event)),
                      "incoming-only": false
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_q_btn, {
                        "no-caps": "",
                        label: _ctx.$t('attach'),
                        color: "primary",
                        disable: !_ctx.canCreatePayment,
                        onClick: _withModifiers(_ctx.addNewPayment, ["stop"])
                      }, null, 8, ["label", "disable", "onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (
                  (_ctx.accounts_tab === 'account_selector' &&
                    _ctx.selectedExistingBill &&
                    !_ctx.selectedExistingBill.Counterparty?.Id) ||
                  _ctx.accounts_tab === 'new_bill'
                )
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('select_counterparty_invoice')), 1),
                    (_ctx.selectedExistingCP || !_ctx.isNewCPModelEmpty)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.selectedExistingCP
                        ? _ctx.selectedExistingCP.Name
                        : _ctx.newCPModel.Name + ", " + _ctx.newCPModel.INN), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_btn, {
                      ref: "cpMenuTrigger",
                      dense: "",
                      flat: "",
                      color: "accent",
                      size: "md",
                      icon: "add",
                      class: "q-pa-none",
                      onClick: _withModifiers(_ctx.openCpMenu, ["stop"])
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_mosta_context_menu, {
                      visible: _ctx.cpMenuOpen,
                      position: _ctx.cpMenuPos,
                      "min-width": 300,
                      "z-index": 6010,
                      resizable: "",
                      "max-width": 560,
                      "min-height": 320,
                      "menu-class": "finance-cp-menu-ctx",
                      onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.cpMenuOpen = false)),
                      onContentResize: _ctx.refitCpMenu
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "finance-add-menu",
                          onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(_component_q_tabs, {
                            modelValue: _ctx.counterparties_tab,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.counterparties_tab) = $event)),
                            dense: "",
                            class: "text-grey bg-white",
                            "active-color": "dark",
                            "indicator-color": "accent",
                            align: "justify"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tab, {
                                name: "project_cp",
                                "no-caps": "",
                                label: _ctx.projectName
                              }, null, 8, ["label"]),
                              _createVNode(_component_q_tab, {
                                name: "new_cp",
                                "no-caps": "",
                                label: _ctx.$t('search_create_counterparty')
                              }, null, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_q_tab_panels, {
                            modelValue: _ctx.counterparties_tab,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.counterparties_tab) = $event)),
                            animated: "",
                            class: "full-height bg-white",
                            style: {"overflow":"hidden"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tab_panel, {
                                name: "project_cp",
                                class: "bg-white full-height q-pa-xs",
                                style: {"overflow":"hidden"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmp_project_cps_clients, (c, li) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'c_' + li
                                    }, [
                                      _createElementVNode("span", _hoisted_8, _toDisplayString(c.Name), 1),
                                      _createVNode(_component_simple_selector, {
                                        ref_for: true,
                                        ref: "cp_selector",
                                        class: "q-my-sm",
                                        "data-to-entity": 
                                (ent) => _ctx.counterpartyFromFilter(ent)
                              ,
                                        "data-from-entity": 
                                (ent) =>
                                  _ctx.counterpartyToFilter(
                                    ent,
                                    this.theModel?.find((m) => m.Id === ent.Id),
                                  )
                              ,
                                        "object-filter": false,
                                        "load-more": 
                                (f, c, offset) => {
                                  if (offset > 0) {
                                    return [];
                                  }
                                  return _ctx.tmp_project_cps_clients[li]
                                    .Counterparties;
                                }
                              ,
                                        "m-height": 0,
                                        filter_value: "",
                                        "element-type": 12,
                                        "single-load": true,
                                        "hide-checkboxes": true,
                                        onItemSelected: () => {},
                                        modelValue: _ctx.tmp_project_cps,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tmp_project_cps) = $event)),
                                        "allow-multiple": true
                                      }, null, 8, ["data-to-entity", "data-from-entity", "load-more", "modelValue"])
                                    ]))
                                  }), 128))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_tab_panel, {
                                name: "new_cp",
                                class: "bg-white full-height q-pa-xs",
                                style: {"overflow":"hidden"}
                              }, {
                                default: _withCtx(() => [
                                  (!_ctx.newCPMode)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createVNode(_component_q_input, {
                                          outlined: "",
                                          dense: "",
                                          ref: "from_search_input",
                                          color: "white",
                                          class: "thin-input q-my-auto",
                                          modelValue: _ctx.cp_search_text,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cp_search_text) = $event)),
                                          "hide-bottom-space": "",
                                          clearable: "",
                                          autofocus: "",
                                          "clear-icon": _ctx.clearIconName,
                                          placeholder: _ctx.$t('search_label'),
                                          debounce: "300",
                                          onClear: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cp_search_text = ''))
                                        }, {
                                          append: _withCtx(() => [
                                            _createVNode(_component_q_icon, {
                                              name: "search",
                                              color: "accent"
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "clear-icon", "placeholder"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
                              [10, 12].includes(_ctx.cp_search_text.length) &&
                              !_ctx.newCPMode
                            )
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        label: _ctx.$t('add_new_counterparty'),
                                        "no-caps": "",
                                        flat: "",
                                        onClick: _ctx.CPShow
                                      }, null, 8, ["label", "onClick"]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.newCPMode)
                                    ? (_openBlock(), _createBlock(_component_aux_selector, {
                                        key: 2,
                                        "model-type": 28,
                                        "input-index": 0,
                                        "filter-model-value": _ctx.cp_search_text,
                                        "show-search-header": false,
                                        modelValue: _ctx.tmp_adding_cps,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tmp_adding_cps) = $event)),
                                        "allow-multiple": false
                                      }, null, 8, ["filter-model-value", "modelValue"]))
                                    : (_openBlock(), _createBlock(_component_counterparty_create_form, {
                                        key: 3,
                                        modelValue: _ctx.newCPModel,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newCPModel) = $event)),
                                        "project-id": _ctx.projectId
                                      }, null, 8, ["modelValue", "project-id"]))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_10, [
                            (_ctx.newCPMode)
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 0,
                                  label: _ctx.$t('back'),
                                  "no-caps": "",
                                  flat: "",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.newCPMode = false))
                                }, null, 8, ["label"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_q_btn, {
                              "no-caps": "",
                              label: _ctx.$t('select_counterparty'),
                              disable: !_ctx.selectedExistingCP && _ctx.isNewCPModelEmpty,
                              color: "primary",
                              onClick: _withModifiers(_ctx.selectBillCounterparty, ["stop"])
                            }, null, 8, ["label", "disable", "onClick"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["visible", "position", "onContentResize"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (
                  (_ctx.selectedExistingCP &&
                    !_ctx.selectedExistingCP.AttachedToClient) ||
                  (!_ctx.isNewCPModelEmpty && !_ctx.selectedExistingClient)
                )
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('client_for_counterparty')) + ":", 1),
                    (_ctx.selectedExistingClient)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.selectedExistingClient.Name), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_btn, {
                      ref: "clientMenuTrigger",
                      onClick: _withModifiers(_ctx.openClientMenu, ["stop"]),
                      dense: "",
                      flat: "",
                      color: "accent",
                      size: "md",
                      icon: "add",
                      class: "q-pa-none"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_mosta_context_menu, {
                      visible: _ctx.clientMenuVisible,
                      position: _ctx.clientMenuPos,
                      "min-width": 260,
                      "z-index": 6020,
                      resizable: "",
                      "max-width": 480,
                      "default-height": 380,
                      "min-height": 200,
                      "menu-class": "finance-client-menu-ctx",
                      onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.clientMenuVisible = false))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "finance-client-menu",
                          onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(_component_aux_selector, {
                            "model-type": 27,
                            "input-index": 0,
                            "allow-multiple": false,
                            "limit-height-to-container": true,
                            modelValue: _ctx.tmp_cp_clients,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tmp_cp_clients) = $event)),
                            onSelectorClosed: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clientMenuVisible = false))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["visible", "position"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.accounts_tab === 'account_selector')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_app_tooltip, {
                    text: _ctx.attachHintText,
                    disabled: !_ctx.attachHintText
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        "no-caps": "",
                        label: 
                        _ctx.$t('attach')+' ' +
                        (_ctx.selectedExistingPayment ? _ctx.$t('payment_invoice') : _ctx.$t('payment_invoice'))
                      ,
                        disable: !_ctx.canAttachBill,
                        color: "primary",
                        onClick: _withModifiers(_ctx.AttachBill, ["stop"])
                      }, null, 8, ["label", "disable", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["text", "disabled"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.accounts_tab === 'new_bill')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_app_tooltip, {
                    text: _ctx.createBillHintText,
                    disabled: !_ctx.createBillHintText
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        "no-caps": "",
                        label: _ctx.$t('create_invoice'),
                        color: "primary",
                        disable: !_ctx.canCreateBill,
                        onClick: _withModifiers(_ctx.addNewBill, ["stop"])
                      }, null, 8, ["label", "disable", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["text", "disabled"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["visible", "position", "onClose", "onContentResize"]),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.tmp_connections.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.tmp_connections[0].name) + ":", 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.qtyOrPercentLabel(_ctx.tmp_connections[0].section)), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('amount')), 1),
                  _cache[23] || (_cache[23] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmp_connections.slice(1), (row, idx) => {
                  return (_openBlock(), _createElementBlock("tbody", {
                    style: {"display":"contents"},
                    key: 'conn_line_' + idx
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'finance-section__section-head': row.header_row })
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(!row.header_row ? row.idx + "." : "") + " ", 1),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(row.header_row ? row.name + ":" : ""), 1),
                            (!row.header_row && row.connection.bill)
                              ? (_openBlock(), _createBlock(_component_bill_row, {
                                  key: 0,
                                  el: row.connection.bill,
                                  "bill-type": row.connection.billRowType,
                                  onInfoClosed: _ctx.onFinanceInfoClosed
                                }, null, 8, ["el", "bill-type", "onInfoClosed"]))
                              : (!row.header_row && row.connection.movement)
                                ? (_openBlock(), _createBlock(_component_movement_row, {
                                    key: 1,
                                    el: row.connection.movement,
                                    "show-positions": false,
                                    "show-positions-toggle": _ctx.hasPositionsToggle(row.connection.movement),
                                    "positions-expanded": _ctx.isPositionsExpanded(row.connection.movement.Id),
                                    onTogglePositions: ($event: any) => (_ctx.togglePositions(row.connection.movement.Id))
                                  }, null, 8, ["el", "show-positions-toggle", "positions-expanded", "onTogglePositions"]))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            (!row.header_row && row.connection.bill && _ctx.roundTo(row.connection.bill.PayedPercent, 4) < 100 && row.connection.bill.Descriptor !== 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.roundTo(row.connection.bill?.PayedPercent, 4)) + "% ", 1))
                              : (!row.header_row && row.connection.bill)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.money(row.connection.bill?.TotalAmount)), 1))
                                : _createCommentVNode("", true),
                            (
                          !row.header_row && row.connection.bill &&
                          _ctx.roundTo(row.connection.bill?.PayedPercent, 4) < 100 &&
                          row.connection.bill?.Descriptor !== 3
                        )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createVNode(_component_payment_progress, {
                                    narrow: false,
                                    width: 60,
                                    percent: Math.round(row.connection.bill?.PayedPercent)
                                  }, null, 8, ["percent"]),
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.money(row.connection.bill?.PayedAmount)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 2),
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'finance-section__section-head': row.header_row })
                      }, [
                        (row.header_row)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.qtyOrPercentLabel(row.section)), 1)
                            ], 64))
                          : (row.connection.bill && row.connection.bill.Descriptor !== 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.roundTo(row.connection.percent, 2)) + "% ", 1))
                            : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("td", {
                        class: _normalizeClass({ 'finance-section__section-head': row.header_row })
                      }, [
                        (row.header_row)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('amount')), 1)
                            ], 64))
                          : (!_ctx.isSinglePositionMovement(row.connection))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.money(row.connection.amount)), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("td", {
                        class: _normalizeClass(["cell-actions", { 'finance-section__section-head': row.header_row }])
                      }, [
                        (
                      !row.header_row && _ctx.canEdit && (
                        !row.connection.bill ||
                        row.connection.bill.CanBeDetached ||
                        row.connection.bill.Descriptor === 3
                      )
                    )
                          ? (_openBlock(), _createBlock(_component_app_tooltip, {
                              key: 0,
                              text: _ctx.$t('detach')
                            }, {
                              activator: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                  disable: _ctx.isLoading,
                                  flat: "",
                                  class: "cursor-pointer",
                                  size: "sm",
                                  dense: "",
                                  "no-caps": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_app_icon, {
                                      name: "close",
                                      width: "16px",
                                      color: "#979797",
                                      "hover-color": "#616161",
                                      cursor: "pointer"
                                    }),
                                    (!_ctx.isLoading)
                                      ? (_openBlock(), _createBlock(_component_q_menu, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_card, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_card_section, { class: "row items-center" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_app_icon, {
                                                      name: "delete-outline",
                                                      width: "18px",
                                                      color: "#979797"
                                                    }),
                                                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("sure_delete")), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_q_card_actions, { align: "right" }, {
                                                  default: _withCtx(() => [
                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                      size: "sm",
                                                      flat: "",
                                                      label: _ctx.$t('cancel'),
                                                      color: "dark",
                                                      ref_for: true,
                                                      ref: 'cancelbtn' + idx
                                                    }, null, 8, ["label"]), [
                                                      [_directive_close_popup]
                                                    ]),
                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                      size: "sm",
                                                      flat: "",
                                                      label: _ctx.$t('remove'),
                                                      autofocus: "",
                                                      color: "dark",
                                                      ref_for: true,
                                                      ref: 'okbtn' + idx,
                                                      onClick: ($event: any) => (_ctx.remove(row))
                                                    }, null, 8, ["label", "onClick"]), [
                                                      [_directive_close_popup]
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["disable"])
                              ]),
                              _: 2
                            }, 1032, ["text"]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    (!row.header_row && row.connection.movement)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                          (_ctx.arePositionsVisible(row.connection.movement))
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.connection.movement.Items, (storagepos, idsx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: 'stp'+idsx
                                }, [
                                  (!row.header_row)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, [
                                          _createTextVNode(_toDisplayString(idsx + 1) + ")  ", 1),
                                          _createVNode(_component_position_row, {
                                            id: storagepos.Id,
                                            el: _ctx.getPositionFromNameInstance(storagepos),
                                            "hide-info-btn": true
                                          }, null, 8, ["id", "el"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!row.header_row)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                        _createElementVNode("span", null, _toDisplayString(storagepos.ItemQuantity), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!row.header_row)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.money(storagepos.TotalAmount)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _cache[24] || (_cache[24] = _createElementVNode("td", { class: "pos_cell" }, null, -1))
                                ]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}